import React, { useState } from 'react';
import { Users, UserPlus, Mail, MessageSquare } from 'lucide-react';
import { Button } from '../components/ui/Button';

interface TeamMember {
  id: string;
  name: string;
  role: string;
  avatar: string;
  status: 'online' | 'offline';
}

const initialTeamMembers: TeamMember[] = [
  {
    id: '1',
    name: 'Sarah Johnson',
    role: 'Product Manager',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
    status: 'online'
  },
  {
    id: '2',
    name: 'Michael Chen',
    role: 'Senior Developer',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop',
    status: 'offline'
  },
  {
    id: '3',
    name: 'Emily Rodriguez',
    role: 'UI/UX Designer',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop',
    status: 'online'
  }
];

export const Team = () => {
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>(initialTeamMembers);

  const handleAddMember = () => {
    // TODO: Implement add member functionality
    console.log('Add member clicked');
  };

  const handleMessage = (memberId: string) => {
    // TODO: Implement message functionality
    console.log('Message member:', memberId);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Team Members</h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Manage your team and their access
          </p>
        </div>
        <Button 
          onClick={handleAddMember}
          leftIcon={<UserPlus className="w-4 h-4" />}
        >
          Add Member
        </Button>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
        <div className="divide-y divide-gray-200 dark:divide-gray-700">
          {teamMembers.map((member) => (
            <div key={member.id} className="p-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <img
                    src={member.avatar}
                    alt={member.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div className="ml-4">
                    <h3 className="text-sm font-medium text-gray-900 dark:text-white">
                      {member.name}
                    </h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400">{member.role}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className={`w-2.5 h-2.5 rounded-full ${
                    member.status === 'online' ? 'bg-green-400' : 'bg-gray-400'
                  }`} />
                  <Button 
                    variant="outline" 
                    size="sm" 
                    leftIcon={<Mail className="w-4 h-4" />}
                    onClick={() => handleMessage(member.id)}
                  >
                    Message
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {teamMembers.length === 0 && (
        <div className="text-center py-12">
          <Users className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white">No team members</h3>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Get started by adding a new team member.
          </p>
          <div className="mt-6">
            <Button onClick={handleAddMember}>
              <UserPlus className="w-4 h-4 mr-2" />
              Add Team Member
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};